import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const updateCommentStmtInstruction = `
#### Update Comment
Update a comment in a view or scope. This is useful for updating notes or descriptions in your views and scopes.

- Syntax: \`update comment <order> in <view_name>.<scope_name> to "<comment>";\`
- Example: \`update comment 1 in ProductList.ProductScope to "This data-grid scope should show only available products";\`
`;
export const stmtUpdateStructureComment = ({ order, comment, viewName, scopeName }) => {
    if (scopeName) {
        return `update comment ${order} in ${viewName}.${scopeName} to "${comment}";`;
    }
    return `update comment ${order} in ${viewName} to "${comment}";`;
};
export const updateCommentHandler = createStructureStatementHandler({
    type: 'update comment',
    parse: line => {
        const match = /^update comment (?<order>[\d]+) in (?<viewName>\w+)(.(?<scopeName>\w+))? to "(?<comment>.+)"/.exec(line);
        return match?.groups
            ? {
                type: 'update comment',
                order: Number.parseInt(match.groups.order),
                comment: match.groups.comment,
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.updateComment({
                order: stmt.order,
                comment: stmt.comment,
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
            });
        });
    },
});
//# sourceMappingURL=UpdateCommentStmt.js.map